











import { Vue, Component } from "vue-property-decorator";
import { Getter } from "vuex-class";
import Barrage, { BarrageItem } from "@/common/barrage";
import getUrlParam from '@/common/utils/getUrlParam';
import getActivityType from '@/common/utils/getActivityType';
import fetch from "@/common/api/fetch";
import { AxiosPromiseData } from "@/common/interface";
import CONFIG from "@/common/config";

const NEW_URL : {
  [index: string] : string
}= {
  'solitaireType': 'anon/solitaire/getBarrageList',
  'lessonType': 'anon/lesson/getBarrageList',
  'bargainType': 'anon/bargain/getBarrageList',
  'groupType': 'anon/group/getBarrageList',
  'gachaType': 'anon/gacha/getBarrageList',
  'distributeGroupType': 'anon/distributeGroup/getBarrageList'
}

@Component
export default class BarrageIndex extends Vue {
  @Getter("showInValidModal") showInValidModal!: boolean
  // 添加弹幕功能
  barrage: any;

  mounted() {
    if (getUrlParam("type") === "share" && !this.showInValidModal) {
      const templateType = getActivityType();
      if (templateType === 'tyType' ) {
        fetch.post(`c/xm/show/ty/getBarrageList`,{
          broadcastId: getUrlParam("broadcastId")
        }).then((res: AxiosPromiseData) => {
          setTimeout(() => {
            const barrageList: Array<BarrageItem> = res.data;
            const parentDom = document.querySelector("#main-image-content");
            this.barrage = new Barrage(
              parentDom as HTMLElement,
              barrageList,
              6000
            );
            this.barrage.init();
          }, 1000);
        });
      } else {
        if(templateType === 'distributeType'){
          fetch.Sales("anon/show/distribute/fetchBarrageList", {
            activityId: getUrlParam("broadcastId")
          })
          .then((res: any) => {
            setTimeout(() => {
              const barrageList: Array<BarrageItem> = res.result;
              const parentDom = document.querySelector("#main-image-content");
              this.barrage = new Barrage(
                parentDom as HTMLElement,
                barrageList,
                6000
              );
              this.barrage.init();
            }, 1000);
          });
        } else if (templateType === 'distributeGroupType') {
          fetch.Sales(NEW_URL[getActivityType()], {
            activityId: getUrlParam("broadcastId")
          }).then((res: AxiosPromiseData) => {
            setTimeout(() => {
              const barrageList: Array<BarrageItem> = res.result;
              const parentDom = document.querySelector("#main-image-content");
              this.barrage = new Barrage(
                parentDom as HTMLElement,
                barrageList,
                6000
              );
              this.barrage.init();
            }, 1000);
          })
        } else {
          fetch.newpost(NEW_URL[getActivityType()], {
            activityId: getUrlParam("broadcastId")
          }).then((res: AxiosPromiseData) => {
            setTimeout(() => {
              const barrageList: Array<BarrageItem> = res.result;
              const parentDom = document.querySelector("#main-image-content");
              this.barrage = new Barrage(
                parentDom as HTMLElement,
                barrageList,
                6000
              );
              this.barrage.init();
            }, 1000);
          })
        }
      }
    }
  }

  destroyed() {
    if (this.barrage && this.barrage.unregister) {
      this.barrage.unregister();
    }
  }
}
